import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
// CSS StyleSheets
import Styles from "../../assets/css/NavFoot/Footer.module.css";
import { useGlobalState } from "../../Functions/GlobalStates";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const footerRef = useRef(null); // Using a ref to target the footer
  // const { isNavbarVisible, setIsNavbarVisible } = useGlobalState();
  const isWithinRangeRef = useRef(false); // Ref to store the latest value of isWithinRange
  // const [isWithinRange, setIsWithinRange] = useState(false);

  useEffect(() => {
    const handleResize1 = () => {
      const width = window.innerWidth;
      const isWithinRange = width >= 0 && width <= 600;
      isWithinRangeRef.current = isWithinRange; // Update the isWithinRangeRef to avoid inconsistancy
    };

    // Call it on mount
    handleResize1(); // Run on every screen resize to update the isWithinRangeRef.current to avoid inconsistancy

    // Add event listener to handle resize
    window.addEventListener("resize", handleResize1);

    // Clean up on unmount
    return () => {
      window.removeEventListener("resize", handleResize1);
    };
  }, []);

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      debounce(([entry]) => {
        if (entry.isIntersecting) {
          // console.log("Observer: Element is visible");
          setIsVisible(true);
        } else {
          // console.log("Observer: Element is not visible");
          setIsVisible(false);
        }
      }, 500), //delay
      { threshold: 0.2 } // Trigger when 20% of the component is visible
    );

    const footer = footerRef.current;
    if (footer) observer.observe(footer);

    // Resize Event Listener
    const handleResize2 = () => {
      if (footer) {
        observer.unobserve(footer); // Remove the old observer
        observer.observe(footer); // Re-observe after resize
        // console.log("running on reside observer");
      }
    };
    const debouncedReSizeHandle = debounce(handleResize2, 100);

    window.addEventListener("resize", debouncedReSizeHandle);

    return () => {
      if (footer) observer.unobserve(footer);
      window.removeEventListener("resize", handleResize2);
    };
  }, []);

  const FooterLogoImages = require.context(
    "../../assets/images/Logos",
    false,
    /\.(png|jpe?g|webp)$/
  );
  const FooterLogos = [FooterLogoImages("./Affiliators.png")];

  const FooterSocialLogoImages = require.context(
    "../../assets/images/Logos/SocialLogos",
    false,
    /\.(png|jpe?g|webp)$/
  );
  const FooterSocialLogos = [
    FooterSocialLogoImages("./Facebook.png"),
    FooterSocialLogoImages("./Instagram.png"),
    FooterSocialLogoImages("./Youtube.png"),
  ];

  return (
    <div
      ref={footerRef}
      className={`${Styles.FooterContainer} ${isVisible ? Styles.visible : ""}`}
    >
      <div className={Styles.FooterSection1Secton2Wrapper}>
        <section className={Styles.FooterSection1Container}>
          <div className={Styles.FooterSection1LogoSocialContainer}>
            <img src={`${FooterLogos[0]}`} alt="Loading Logo" />
            <div className={Styles.FooterSection1SocialImagesContainer}>
              <a
                href="https://web.facebook.com/AffiliatorsOfficial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${FooterSocialLogos[0]}`}
                  alt="FACEBOOK lOGO Loading"
                />
              </a>
              <a
                href="https://www.instagram.com/affiliatorsofficial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${FooterSocialLogos[1]}`}
                  alt="INSTAGRAM lOGO Loading"
                />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${FooterSocialLogos[2]}`}
                  alt="YOUTUBE lOGO Loading"
                />
              </a>
            </div>
          </div>
        </section>
        <section className={Styles.FooterSection2Container}>
          <div className={Styles.FooterSection2SiteMapContainer}>
            <div className={Styles.FooterSection2SiteMapCate1BlogsContainer}>
              <h1>PROBLEM SOLVING</h1>
              <div className={Styles.FooterSection2SiteMap1BlogsContainer}>
                <NavLink
                  to="/problemsolving/npmerrors"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Npm Errors
                </NavLink>
                <NavLink
                  to="/problemsolving/slowlaptop"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Slow Laptop
                </NavLink>
                <NavLink
                  to="/problemsolving/hostingdomainsolution"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Hosting & Domain Solutions
                </NavLink>
                <NavLink
                  to="/problemsolving/mobileresponsiveness"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Mobile Responsiveness
                </NavLink>
                <NavLink
                  to="/problemsolving/ecommercesolutions"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  E-Commerce Solutions
                </NavLink>
                <NavLink
                  to="/problemsolving/securitysolutions"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Security Solutions
                </NavLink>
              </div>
            </div>
            <div className={Styles.FooterSection2SiteMapCate2BlogsContainer}>
              <h1>REALLIFE GADGETS</h1>
              <div className={Styles.FooterSection2SiteMap2BlogsContainer}>
                <NavLink
                  to="/reallifegadgets/nightsleepmask"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Night Sleep Mask
                </NavLink>
                <NavLink
                  to="/reallifegadgets/smartclock"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Electric Spin Scrubber
                </NavLink>
                <NavLink
                  to="/reallifegadgets/pushupboard"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  ChargeablePoleSaw ChainSaw
                </NavLink>
                <NavLink
                  to="/reallifegadgets/electricspinscrubber"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Push Up Board
                </NavLink>
                <NavLink
                  to="/reallifegadgets/rechargeablespotlight"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  RechargeableSpotlight
                </NavLink>
                <NavLink
                  to="/reallifegadgets/chargeablepolesawchainsaw"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Smart Clock
                </NavLink>
              </div>
            </div>
            <div className={Styles.FooterSection2SiteMapCate3BlogsContainer}>
              <h1>PERFECT GIFTS GUIDE</h1>
              <div className={Styles.FooterSection2SiteMap3BlogsContainer}>
                <NavLink
                  to="/PerfectGiftsGuide/goldplatedflower"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Gold Plated Flower
                </NavLink>
                <NavLink
                  to="/PerfectGiftsGuide/musclemassager"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Muscle Massager
                </NavLink>
                <NavLink
                  to="/PerfectGiftsGuide/advanceddrone"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Advanced Drone
                </NavLink>
                <NavLink
                  to="/PerfectGiftsGuide/oled"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Summer Dress
                </NavLink>
                <NavLink
                  to="/PerfectGiftsGuide/summerdress"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Fleece Balaclava
                </NavLink>
                <NavLink
                  to="/PerfectGiftsGuide/fleecebalaclava"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  OLED
                </NavLink>
              </div>
            </div>
            <div className={Styles.FooterSection2SiteMapCate4BlogsContainer}>
              <h1>INFORMATIONAL TOPICS</h1>
              <div className={Styles.FooterSection2SiteMap4BlogsContainer}>
                <NavLink
                  to="/comingsoon"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Health & Wellness
                </NavLink>
                <NavLink
                  to="/comingsoon"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Career Development
                </NavLink>
                <NavLink
                  to="/comingsoon"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Productivity & Time Management
                </NavLink>
                <NavLink
                  to="/comingsoon"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Self-Improvement
                </NavLink>
                <NavLink
                  to="/comingsoon"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Motivation & Inspiration
                </NavLink>
                <NavLink
                  to="/comingsoon"
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                >
                  Financial Growth
                </NavLink>
              </div>
            </div>
          </div>
        </section>
      </div>
      <hr className={Styles.FooterSection3CopyrightHr} />
      <section className={Styles.FooterSection3CopyrightContainer}>
        <p>Year 2025 @Copyright All Rights Are Reserved</p>
      </section>
    </div>
  );
};

export default Footer;
